import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { urls } from './urls';


@Injectable({
  providedIn: 'root'
})
export class BaseService {
  constructor() { }

  protected getUrl(name: string): string {
    return this.getEndpoint() + this.getApiPath() + urls[name];
  }

  protected setUrl(name: string): string {
    return this.getEndpoint() + this.getApiPath() + "/" + name;
  }

  private getEndpoint() {
    return environment.endpoint;
  }

  private getApiPath() {
    return environment.apiPath;
  }
}
